/**
 * Three-phase energy sensor config
 * API fields: watt_hour_total, watt_hour_r, watt_hour_s, watt_hour_t
 * (or real_power_total, real_power_r, real_power_s, real_power_t)
 */
export type ThreePhaseMetricId = 'watt_hour' | 'real_power'

export const THREE_PHASE_METRIC_CONFIG: Record<
  ThreePhaseMetricId,
  { id: ThreePhaseMetricId; label: string; unit: string }
> = {
  watt_hour: { id: 'watt_hour', label: 'Energy', unit: 'Wh' },
  real_power: { id: 'real_power', label: 'Power', unit: 'W' },
}

export type PhaseKey = 'total' | 'r' | 's' | 't'

export const PHASE_LABELS: Record<PhaseKey, string> = {
  total: 'Total',
  r: 'R',
  s: 'S',
  t: 'T',
}

/** IEC/工業常用三相顏色：R=紅, S=黃, T=藍, Total=灰白(總和) */
export const PHASE_COLORS: Record<PhaseKey, string> = {
  total: '#94a3b8',
  r: '#ef4444',
  s: '#eab308',
  t: '#3b82f6',
}

export const PHASE_ORDER: PhaseKey[] = ['total', 'r', 's', 't']
